export default "__VITE_ASSET__dd59d609__"